/*
 * author: nick.arcuri@spartan.com
 * date: 07/15/2020
 *
 * this module pulls data from the Contentful API to populate the
 * sponsors tiles at the bottom of page
 *
 * CONTENTFUL_ACCESS_TOKEN, CONTENTFUL_SPACE_ID, and NAVIGATION_CONTENTFUL_ENTRY_ID
 * are all defined via the webpack.DefinePlugin as environment variables
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createClient } from 'contentful';
import { internationalSingleton } from './International';
import GlobalSponsorsElement from '../tsx/GlobalSponsors';
export default function GlobalSponsors() {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var contentfulClient, contentfulParams, data, sponsorsData, sponsorEl, el, err_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!process.env.CONTENTFUL_SPACE_ID ||
                        !process.env.CONTENTFUL_ACCESS_TOKEN) {
                        return [2 /*return*/];
                    }
                    contentfulClient = createClient({
                        space: process.env.CONTENTFUL_SPACE_ID,
                        accessToken: process.env.CONTENTFUL_ACCESS_TOKEN,
                        environment: (_a = process.env.CONTENTFUL_ENV) !== null && _a !== void 0 ? _a : 'master',
                    });
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, internationalSingleton.asyncInit];
                case 2:
                    _c.sent();
                    contentfulParams = {
                        include: 6,
                        locale: internationalSingleton.countryCode,
                    };
                    return [4 /*yield*/, contentfulClient.getEntry(process.env.SPONSORS_CONTENTFUL_ENTRY_ID, contentfulParams)];
                case 3:
                    data = _c.sent();
                    sponsorsData = (_b = data === null || data === void 0 ? void 0 : data.fields) === null || _b === void 0 ? void 0 : _b.sponsors;
                    console.log('SPONSOR: ', sponsorsData);
                    if (sponsorsData) {
                        sponsorEl = GlobalSponsorsElement(sponsorsData);
                        el = document.querySelector('#global-sponsors');
                        if (el)
                            el.replaceWith(sponsorEl);
                    }
                    else {
                        console.warn('No sponsorship data returned from contentful');
                    }
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _c.sent();
                    console.error(err_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}
